import { useEffect, useState } from "react";
import {
  getLocalStorage,
  setLocalStorage,
} from "../../../helpers/get-set-local-storage";
import {
  IMyAccess,
  organizationConstants,
} from "../../../constants/organizationConstants";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setMessage } from "../../../../store/slices/Notification";
import { localStorageConstants } from "../../../constants/localStorageConstants";
const useDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [myAccess, setMyAccess] = useState<IMyAccess[]>([]);
  const [userAccess, setUserAccess] = useState<any>({});
  const dispatch = useDispatch();
  const navigation = useNavigate();

  useEffect(() => {
    let token = getLocalStorage(localStorageConstants.TOKEN);
    let user = getLocalStorage(localStorageConstants.USER);
    if (token && user) {
      let myAccess: any = [];
      const userTenants = user.userTenants.reduce((acc: any, item: any) => {
        acc[item.tenantId] = item;
        if (organizationConstants?.[item.tenantId]) {
          myAccess.push(organizationConstants?.[item.tenantId]);
        }
        return acc;
      }, {});
      setMyAccess(myAccess);
      setUserAccess(userTenants);
      setIsLoading(false);
    }
  }, []);

  const onItemClick = (item: IMyAccess) => {
    if (item.isRedirect && item.redirectUrl) {
      setLocalStorage(localStorageConstants.ORG_ID, item.orgId);
      setLocalStorage(
        localStorageConstants.ROLE,
        userAccess[item.orgId].roleNames[0]
      );
      navigation(`${item.redirectUrl}`);
    } else {
      dispatch(
        setMessage({
          type: "warning",
          message: `This functionality is not available at the moment`,
        })
      );
    }
  };

  return { myAccess, isLoading, onItemClick };
};

export default useDashboard;
